import {structure as location} from '@dofleini/location';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import {memo, useEffect, useMemo} from 'react';
import {useMap} from 'react-leaflet';

import cubaProvBoundaries from '@/components/Dashboard/MapHeatZone/cubaMapProvBoundaries.json';

const cubaBoundaries = [
  [25.085598897064777, -70.91674804687501],
  [17.727758609852284, -87.97851562500001]
];

const CubaMapInternalLayout = ({children, zoomWithValue, isOnClickActive, municipality, province, center}) => {
  const parentMap = useMap();

  const isMunicipalLevel = useMemo(() => !!municipality, [municipality]);
  const isProvincialLevel = useMemo(() => !!province, [province]);

  const boundary = useMemo(() => {
    let provinceAcronym;
    if (isMunicipalLevel)
      provinceAcronym = location.findProvinceByMunicipalityCode(municipality)?.acronym;
    if (isProvincialLevel)
      provinceAcronym = location.findProvinceByAcronym(province)?.acronym;
    if (provinceAcronym)
      return cubaProvBoundaries[provinceAcronym];
    return cubaBoundaries;
  }, [isMunicipalLevel, isProvincialLevel, municipality, province]);

  useEffect(() => {
    parentMap.setMaxBounds(boundary);
    if (isMunicipalLevel || isProvincialLevel) {
      parentMap.setMinZoom(10);
    }
    if ((isMunicipalLevel || isProvincialLevel) && !zoomWithValue) {
      parentMap.setZoom(9);
    }
    if (zoomWithValue && !isOnClickActive) {
      parentMap.setZoom(12);
    }
  }, [boundary, isMunicipalLevel, isOnClickActive, isProvincialLevel, parentMap, zoomWithValue]);

  useEffect(() => {
    const isNotZeroArray = isEqual(center, [0, 0]);
    if (!isNotZeroArray)
      parentMap.flyTo(center, parentMap.getZoom());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentMap]);

  return children;
};

CubaMapInternalLayout.propTypes = {
  zoomWithValue: PropTypes.any,
  province: PropTypes.string,
  municipality: PropTypes.string,
  center: PropTypes.any,
  isOnClickActive: PropTypes.bool
};

CubaMapInternalLayout.defaultProps = {};

export default memo(CubaMapInternalLayout);
